module.exports = __webpack_public_path__ + "static/media/Afgan.ed4441e3.jpg";